import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
@Component({
    selector: 'biz-grid-selection-count',
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `Number of selected rows: {{numberOfSelectedRows}}`
})
export class BizGridSelectionCountComponent {
    @Input() numberOfSelectedRows: number = 0;
}